const zhTW = {
  nav: {
    home: '首頁',
    sell: '我要賣',
    wanted: '我要徵',
    favorites: '我的收藏',
    chat: '聊聊',
    orders: '我的訂單',
    login: '登入 / 註冊',
    logout: '登出',
    profile: '個人檔案',
    dogWalking: '幫溜狗',
    adoption: '認養',
  },
  hero: {
    title: '寵物用品二手市集',
    subtitle: '給毛孩最好的，也給地球最好的',
    searchPlaceholder: '搜尋寵物用品...',
  },
  product: {
    price: '價格',
    condition: '商品狀態',
    location: '地點',
    contactSeller: '聯繫賣家',
    addFavorite: '加入收藏',
  },
  auth: {
    login: '登入',
    register: '註冊',
    email: '電子信箱',
    password: '密碼',
    name: '姓名',
  },
  common: {
    loading: '載入中...',
    noResults: '找不到結果',
    viewAll: '查看全部',
    back: '返回',
    save: '儲存',
    cancel: '取消',
    delete: '刪除',
    confirm: '確認',
  },
};

export default zhTW;
